import { Button } from '@biq/apex-ui';
import React from 'react';
import { Grid } from '@mui/material';
import { tqlResultsEmptyStateStyles } from './tql-editor-helper';

interface TQLUnsupportedQueryViewProps {
    onClick: () => void;
}

export const TQLUnsupportedQueryView = ({
    onClick,
}: TQLUnsupportedQueryViewProps): React.JSX.Element => {
    return (
        <Grid sx={tqlResultsEmptyStateStyles.emptyStateContainer}>
            <Grid sx={tqlResultsEmptyStateStyles.emptyStateTitleText}>
                Not supported in this view, use the LifeGraph Explorer
            </Grid>
            <Grid>
                <Button size='large' onClick={onClick}>
                    OPEN LIFEGRAPH EXPLORER
                </Button>
            </Grid>
        </Grid>
    );
};
